import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateColumn',
  pure: false
})
export class TranslateColumnPipe implements PipeTransform {

  private columnTranslationMapping: { [key: string]: string } = {
    'No': 'NUMBER_NO',
    'BusinessName': 'BUSINESS',
    'Title': 'TITLE',
    'CreatedOn': 'CREATED_ON',
    'DoneOn': 'DONE_ON'
  };

  constructor(private translate: TranslateService) {}

  transform(columnName: string): string {
    const translationKey = this.columnTranslationMapping[columnName] || columnName;
    return this.translate.instant(translationKey);
  }
}


